export default "__VITE_ASSET__CU7HkC8E__"